<nav class="tab-bar">
  <div
    class="tab-bar__pill sidenav-inner-links new-mobile-menu"
    [style.--tab-bar-count]="items().length"
    [style.--tab-bar-active]="activeIndex()"
  >
    @if (activeIndex() >= 0) {
      <span class="tab-bar__indicator"></span>
    }

    @for (item of items(); track item.route) {
      <a
        class="tab-bar__tab sidebar-link"
        dojoSenseiId="shell.nav"
        [senseiKey]="item.route"
        [routerLink]="item.route"
        [class.active]="activeIndex() === $index"
        dojoHaptic
      >
        @if (item.route === profileRoute()) {
          <dojo-profile-avatar
            class="tab-bar__icon"
            [size]="iconSize"
            [color]="profileAvatarColor()"
            [initial]="profileAvatarInitial()"
          />
        } @else {
          <dojo-icon
            class="tab-bar__icon"
            [size]="iconSize"
            [icon]="item.icon"
            [alt]="labelKey(item) | transloco"
            [iconClass]="'feature-nav-icon feature-nav-icon--' + item.route"
          />
        }
        <span class="tab-bar__label">{{ labelKey(item) | transloco }}</span>
      </a>
    }
  </div>
</nav>
